const toggle = (e) => {
    const target = e.target.closest('.js-toggle-button')

    if (target) {
        e.preventDefault()
        const toggleElement = target.closest('.js-toggle')
        const toggleContent = toggleElement.querySelector('.js-toggle-content')
        $(toggleContent).slideToggle(300)
        activateElement(toggleElement)
    }
};

const activateElement = (toggleElement) => {
    const activatedElement = toggleElement.querySelector('.js-toggle-active')
    if (activatedElement) {
        activatedElement.classList.toggle('active')
    }
};

document.addEventListener('click', toggle)